import { createFileRoute, redirect } from "@tanstack/react-router"

/** Moderation lives under Automations now. */
export const Route = createFileRoute("/w/$workspace/settings/moderation/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/w/$workspace/automations/moderation", params, replace: true })
  },
})
